import { CultureInfo } from '../culture-info.model';
import { CultureInfoCkb } from './ckb';

/**
 * @ignore
 */
export const CultureInfoCkbIR: CultureInfo = {
  name: 'ckb-IR',
  displayName: 'کوردیی ناوەندی (ئێران)',
  iso3LanguageCode: 'ckb',
  iso2LanguageCode: 'ckb',
  ietfLanguageTag: 'ckb-IR',
  parent: CultureInfoCkb
};
